module.exports = __webpack_public_path__ + "img/convidar01.3703c507.jpg";